import Vue from 'vue';
import Errors from '../classes/Errors';
import Swiper from 'swiper/bundle';

Vue.component('winners-slider-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            nameSwiper: null,
            imageSwiper: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() { 
        this.initSwiperNames();
        this.initSwiperImages();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initSwiperNames() {
            // init Swiper:
            this.nameSwiper = new Swiper('.winners-slider__name-holder', {
                loop: true,
                slidesPerView: 1.2,
                spaceBetween: 10,
                centeredSlides: true,
                initialSlide: 2,
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                    },
                    // when window width is >= 480px
                    480: {
                        spaceBetween: 20,
                        slidesPerView: 1.4,
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 1.4,
                        spaceBetween: 70,
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerView: 2.4,
                        spaceBetween: 70,
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerView: 2.6,
                        spaceBetween: 70,
                    },
                    // when window width is >= 1440px
                    1440: {
                        slidesPerView: 3,
                        spaceBetween: 70,
                    }
                  }
              });            
        },
        initSwiperImages() {
            // init Swiper:
            this.imageSwiper = new Swiper('.winners-slider__image-holder', {
                loop: true,
                slidesPerView: 1.2,
                spaceBetween: 15,
                centeredSlides: true,
                initialSlide: 0,
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                      slidesPerView: 1.2,
                      spaceBetween: 15,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.4,
                        spaceBetween: 20,
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 1.4,
                        spaceBetween: 70,
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerView: 2.4,
                        spaceBetween: 70,
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerView: 2.6,
                        spaceBetween: 70,
                    },
                    // when window width is >= 1440px
                    1440: {
                        slidesPerView: 3,
                        spaceBetween: 70,
                    }
                  }
              });

            // this.imageSwiper.on('slideChange', function () {
            //     console.log('slide changed');
            // });
            this.nameSwiper.on('progress', (swiper, progress) => {
                this.imageSwiper.setProgress(1 - progress)
            });
        }
    }
});
